// Dependencies
import styled, { css } from "styled-components";

// Utils
import { theme } from "config/theme";

// Types
type ContainerStyleProps = {
    isInvalid?: boolean;
    hasBorder: boolean;
};

export const Container = styled.div<ContainerStyleProps>`
    display: inline-block;
    width: 100%;

    input.native-input {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-size: 0.875rem;
        font-weight: 400;

        letter-spacing: 0;
        line-height: 1.428;
        border: 1px solid ${theme.colors.base[400]};
        border-radius: 4px;

        width: 100%;
        height: 40px;
        padding: 12.25px 14px;

        box-sizing: border-box;

        &:disabled {
            background-color: ${theme.colors.base[100]};
            border-color: ${theme.colors.base[400]};
        }

        &:focus,
        &:focus-visible,
        &:hover {
            background-color: ${theme.colors.base[100]};
            border-color: ${theme.colors.base[500]};
            outline: 0;
        }

        ${({ isInvalid }) =>
            !!isInvalid &&
            css`
                border-color: ${theme.colors.system.danger[300]};
            `}

        ${({ hasBorder }) =>
            !hasBorder &&
            css`
                border: transparent;
            `}
    }

    .native-input::-webkit-search-cancel-button {
        display: none;
    }
`;
